import { createAction } from '../../../core/helpers'

import { FETCH_AWARD } from '../action-types'

export const cleanupFetchAward = createAction(FETCH_AWARD.CLEANUP)
